// Decision 5 — a USD-per-year CAGR must show the FX basis behind its number.
// The formula already records every rate it applied and every year it dropped
// (functions/index.js, CAGR_USD branch); without this the reader sees a bare
// percentage and cannot tell which years it covers or what rates produced it.
//
// Field names here are the ones the engine actually writes: `year_end_rate`
// (not `rate`), and each dropped entry carries EITHER a fiscal_year (an open
// year, or one with no registered rate) OR a question_id (a year left blank).
export default function UsdCagrNarration({ sv }) {
  const used = Array.isArray(sv.years_used) ? sv.years_used : [];
  const dropped = Array.isArray(sv.years_dropped) ? sv.years_dropped : [];
  const cur = sv.reporting_currency || '';
  const num = v => (typeof v === 'number' ? v.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  }) : '—');

  return (
    <div style={{ fontSize: 12, color: 'var(--color-text-secondary)', marginBottom: 4 }}>
      <p style={{ marginBottom: 4 }}>
        Each year converted to USD at that year&apos;s December year-end rate
        {cur ? ` from ${cur}` : ''}
        {typeof sv.actual_periods === 'number' ? ` — ${sv.actual_periods} period${sv.actual_periods === 1 ? '' : 's'}` : ''}.
      </p>
      {used.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', fontSize: 12, minWidth: 320 }}>
            <thead>
              <tr style={{ textAlign: 'left' }}>
                <th style={{ padding: '2px 10px 2px 0' }}>Year</th>
                <th style={{ padding: '2px 10px 2px 0' }}>{cur || 'Reporting'}</th>
                <th style={{ padding: '2px 10px 2px 0' }}>Year-end rate</th>
                <th style={{ padding: '2px 0' }}>USD</th>
              </tr>
            </thead>
            <tbody>
              {used.map(y => (
                <tr key={y.fiscal_year}>
                  <td style={{ padding: '2px 10px 2px 0' }}>{y.fiscal_year}</td>
                  <td style={{ padding: '2px 10px 2px 0', fontVariantNumeric: 'tabular-nums' }}>{num(y.value_reporting)}</td>
                  <td style={{ padding: '2px 10px 2px 0', fontVariantNumeric: 'tabular-nums' }}>{y.year_end_rate ?? '—'}</td>
                  <td style={{ padding: '2px 0', fontVariantNumeric: 'tabular-nums' }}>{num(y.value_usd)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {dropped.length > 0 && (
        <p style={{ marginTop: 4 }}>
          Excluded:{' '}
          {dropped.map((d, i) => (
            <span key={d.fiscal_year ?? d.question_id ?? i}>
              {i > 0 ? '; ' : ''}
              {d.fiscal_year ?? 'a year'} ({d.reason})
            </span>
          ))}
        </p>
      )}
    </div>
  );
}
